export const DEFAULT_INPUT_STYLE =
  'font-metricR  w-full text-[16px] caret-action03 text-bw08 bg-transparent outline-none border-none shadow-none';
export const FILLED_INPUT_CLASS = 'filled w-full';
